/**
 * タグ
 */
import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconClose from '@src/assets/images/common/icon/close/SvgIconClose';
import React from 'react';

type Props = {
  text: string;
  variant?: 'default' | 'gray' | 'primary-light';
  index: number;
  onClick: (index: number) => void;
};

const Tag: React.FC<Props> = ({ text, variant = 'default', index, onClick }) => {
  const tagParentClass = {
    default: 'border border-solid border-gray-250 bg-white text-primary-400',
    gray: 'bg-gray-150',
    'primary-light': 'border border-solid border-primary-500 bg-primary-50 text-primary-500',
  }[variant];
  return (
    <div
      className={`flex min-w-0 items-center gap-[8px] rounded-full px-[16px] py-[6px] ${tagParentClass}`}
    >
      <div className='min-w-0 truncate'>
        <div className='truncate text-xs'>{text}</div>
      </div>
      <button
        className='shrink-0'
        type='button'
        onClick={() => onClick(index)}
      >
        <SvgIconClose
          color={variant === 'gray' ? '#292929' : brandColors['500']}
          style={{
            width: '14px',
            height: '14px',
          }}
        />
      </button>
    </div>
  );
};

export default Tag;
